import { Quote, Star } from "lucide-react";

// Single testimonial card. Structured to map directly onto a future API object.
export default function TestimonialCard({ t, index = 0 }) {
  return (
    <div
      data-testid={`testimonial-card-${t.id}`}
      className="flex h-full flex-col rounded-2xl border border-slate-100 bg-white p-7 shadow-[0_4px_24px_rgba(3,56,106,0.05)] sm:p-8"
    >
      <div className="flex items-center justify-between">
        <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand/10 text-brand">
          <Quote className="h-5 w-5" />
        </span>
        <div className="flex gap-0.5">
          {Array.from({ length: t.rating || 5 }).map((_, i) => (
            <Star key={i} className="h-4 w-4 fill-amber-400 text-amber-400" />
          ))}
        </div>
      </div>

      <p className="mt-6 flex-1 text-[15px] leading-relaxed text-slate-700">"{t.testimonial}"</p>

      <div className="mt-7 flex items-center gap-3.5 border-t border-slate-100 pt-6">
        <span className="flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-navy to-brand font-heading text-lg font-bold text-white">
          {t.company?.charAt(0) || "S"}
        </span>
        <div>
          <p className="text-sm font-bold text-navy">{t.position}</p>
          <p className="text-xs text-slate-500">{t.company}</p>
          <p className="mt-0.5 font-mono-tech text-[10px] uppercase tracking-wider text-brand-ink">{t.service}</p>
        </div>
      </div>
    </div>
  );
}
